<template>
  <div class="reqular">
    <div class="wrapper">
      <!-- start first step -->
      <div class="first-step" id="step_one">
        <div class="row game-card-wrapper">
          <div class="col-12 col-sm-6 col-md-4 game-card-col" v-for="(items,index) in gamePage" :key="items.id">
            <div class="game-card">
              <div class="card-game-holder">
                <div class="card-game-img">
                  <img :src="items.img">
                </div>
                <div class="card-game-text">
                  <p>{{ items.head }}</p>
                  <p>{{ items.title }}</p>
                  <div class="download" @click="downloadPDF(items.link)">
                    <p class="download">{{ items.download }}</p>
                    <i class="fas fa-download"></i>
                  </div>
                </div>
                <div class="card-button">
                  <div class="the-button">
                    <button @click="selectGame(items,index)" class="wro-button secondaryButtons"><span>Start Now</span>
                    </button>
                    <span class="skew-line-w"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end first step -->
    </div>
  </div>
</template>


<script>
import ButtonComponent from "@/components/tools/ButtonComponent";
import LoadingSpinner from "@/components/tools/LoadingSpinner";

export default {
  props: ['userAge','userData'],
  data: () => ({
    filteredGame: [
      {
        head: 'elmentary',
        title: 'There are numerous applications of robots at home and in the daily household. One example is robots that can perform various tasks in our garden. There are robots that clean pools, sow plants, or water flowers. On the Elementary game field, the robot takes on the task of cutting the grass and collecting bad weeds. At the same time, the robot has to watch out for ladybugs that are on the robot\'s path and bring them to safety.',
        img: require('@/assets/img/user/gamePlay/elmentary-virtual-2022-robomission.png'),
        download: 'Download Virtual Regular Elementary Game Guide',
        link: 'https://wro-v.com/backend/assets/uploads/competion_details_link/2022/09/14/20220914124825165362086_competion_details_link.pdf',
        sub: [
          {
            head: '',
            title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            img: require('@/assets/img/user/level 1.png'),
          },
          {
            head: '',
            title: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
            img: require('@/assets/img/user/level 2.png'),
            download: 'Download Virtual Regular Senior Game Guide',
            link: 'https://wro-v.com/backend/assets/uploads/competion_details_link/2022/09/14/20220914124825165362086_competion_details_link.pdf',
          },
        ],
        mission: 0

      },
      {
        head: 'junior',
        title: 'On this playing field, the robot\'s tasks are to assist and extinguish a fire in a factory, to transport hazardous chemicals, and to provide the rescue services with information about the position of people in the factory. At the same time, the robot has to overcome unknown terrain on its way to the factory.',
        img: require('@/assets/img/user/gamePlay/junior-virtual-2022-robomission.png'),
        download: 'Download Virtual Regular Junior Game Guide',
        link: 'https://wro-v.com/backend/assets/uploads/competion_details_link/2022/09/14/20220914124825375280867_competion_details_link.pdf',
        sub: [
          {
            head: '',
            title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            img: require('@/assets/img/user/level 1.png'),
          },
          {
            head: '',
            title: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
            img: require('@/assets/img/user/level 2.png'),
          },
        ],
        mission: 1
      },
      {
        head: 'senior',
        title: 'On the senior playing field, the robot takes on the role of a care and transport robot in a hospital. It is supposed to take laundry to the hospital\'s own laundry shop, bring water to different rooms, and play with the patients. At the same time, the robot has to pay attention to the nurses and visitors as it makes its way through the hospital corridors.',
        img: require('@/assets/img/user/gamePlay/senior-virtual-2022-robomission.png'),
        download: 'Download Virtual Regular Senior Game Guide',
        link: 'https://wro-v.com/backend/assets/uploads/competion_details_link/2022/09/14/202209141248251923607848_competion_details_link.pdf',
        sub: [
          {
            head: '',
            title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            img: require('@/assets/img/user/level 1.png'),
          },
          {
            head: '',
            title: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
            img: require('@/assets/img/user/level 2.png'),
          },
        ],
        mission: 2,
      },

    ],
    selectedGame: null,
    selected_head: null,
    mission: '',
    level: '',
    organizer_id: null,
    gamePage: []
  }),
  components: {LoadingSpinner, ButtonComponent},
  mounted() {

    if (this.userAge.length == 4) {
      this.gamePage = this.filteredGame
    } else {
      this.gamePage = this.filteredGame.filter(el => el.head == this.userAge[0].name)
    }
    this.organizer_id = this.$store.state.InternalSettings[0].organizer_id;

    if(this.userAge[0].name === 'junior') {
      this.mission = 1;
    }

    if(this.userAge[0].name === 'elmentary') {
      this.mission = 0;
    }

    if(this.userAge[0].name === 'senior') {
      this.mission = 2;
    }


  },
  methods: {
    selectGame(items) {

      // set mission index

      $cookies.set('mission', items.mission);

      $cookies.set('robot_name', this.userData.robot_name);
      $cookies.set('robot_color', this.userData.robot_color);

      /*let game = document.getElementById('step_one');
      let level = document.getElementById('step_two');

      // hide choose game
      game.style.display = "none";

      // show game levels
      level.style.display = "block";*/
      this.selectedGame = items.sub;
      this.selected_head = items.head;

      /* Select level from here */
      // set level
      this.level = items.mission;
      $cookies.set('level', this.level);
      // user id
      $cookies.set('id', this.$store.state.userData.id);

      window.location.href = `https://wro-v.com/backend/api/admin/robot3?organizer_id=${this.organizer_id}&id=${this.$store.state.userData.id}&mission=${items.mission}&level=1&robot_name=${this.userData.robot_name}&robot_color=${encodeURIComponent(this.userData.robot_color)}`;

    },

    selectLevel(sub_items, index) {
      // set level
      this.level = this.mission;
      $cookies.set('level', this.level);
      // user id
      $cookies.set('id', this.$store.state.userData.id);
      // redirect to game play
      window.location.href = `https://wro-v.com/backend/api/admin/blockly?organizer_id=${this.organizer_id}&id=${this.$store.state.userData.id}&mission=${this.mission}&level=${this.level}`;
    },
    downloadPDF(fileURL) {
      window.open(fileURL);
    }
  }
}
</script>